import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useQuests } from '../context/QuestContext';
import './StoryQuests.css';
import { tl } from '../utils/inlineI18n';

// Köydeki NPC ekranında, o NPC ile yapılacak hikâye adımları (konuş / teslim et).

/** Hikâye görünümünden bu köyde iş bekleyen NPC adları. */
export function storyNpcTaskNames(story, villageId) {
  const names = new Set();
  (story?.active || []).forEach((q) => {
    q.steps.forEach((s) => {
      if (s.current && (s.type === 'talk' || s.type === 'deliver') && s.npc && (!s.villageId || s.villageId === villageId)) {
        names.add(s.npc);
      }
    });
  });
  return names;
}

/** Görünüm yoksa bir kez yükler (köy ekranı görev penceresinden önce açılabilir). */
export function useStoryView(username) {
  const { story, setStory } = useQuests();
  useEffect(() => {
    if (!username || story) return;
    axios
      .get(`/api/story/status?username=${encodeURIComponent(username)}`)
      .then((res) => {
        if (res.data?.success) setStory(res.data.story, res.data.actionCount);
      })
      .catch(() => {});
  }, [username, story, setStory]);
  return story;
}

const StoryNpcTasks = ({ npcName, villageId, username, onCharacterChange, onSay }) => {
  const { setStory } = useQuests();
  const story = useStoryView(username);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const tasks = [];
  (story?.active || []).forEach((q) => {
    q.steps.forEach((s) => {
      if (s.current && (s.type === 'talk' || s.type === 'deliver') && s.npc === npcName && (!s.villageId || s.villageId === villageId)) {
        tasks.push({ q, s });
      }
    });
  });
  if (!tasks.length && !message) return null;

  const advance = async (q, step) => {
    if (busy) return;
    setBusy(true);
    setError('');
    setMessage('');
    try {
      const res = await axios.post('/api/story/action', { username, action: 'advance', questId: q.id, npc: npcName });
      const data = res.data || {};
      if (!data.success) {
        setError(data.message || tl('İşlem yapılamadı', 'Action failed'));
        return;
      }
      setStory(data.story, data.actionCount);
      if (step?.type === 'talk' && step.dialogue?.length && onSay) {
        onCharacterChange?.();
        onSay(step.dialogue);
        return;
      }
      const msgs = (data.result?.messages || []).join(' ');
      setMessage(tl(`${q.title}: ${msgs || 'görev ilerledi.'} Görevler penceresinden devam edebilirsin.`, `${q.title}: ${msgs || 'quest progressed.'} You can continue from the Quests window.`));
      onCharacterChange?.();
    } catch (e) {
      setError(e?.response?.data?.message || tl('Sunucuya ulaşılamadı', 'Could not reach the server'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="sq-panel sq-npc-tasks">
      {tasks.map(({ q, s }) => {
        const short = s.type === 'deliver' && s.count < s.need;
        return (
          <div key={`${q.id}-${s.id}`} className="sq-npc-task">
            <span className="sq-eyebrow">{tl('Hikâye görevi', 'Story quest')} · {q.title}</span>
            <p className="sq-line">{s.text}</p>
            {s.type === 'deliver' ? (
              <p className="sq-line sq-muted">
                {s.target}: {s.count}/{s.need}
                {short ? ` · ${tl(`${s.need - s.count} tane daha gerekli`, `${s.need - s.count} more needed`)}` : ''}
              </p>
            ) : null}
            <div className="sq-actions">
              <button
                type="button"
                className="auth-button auth-button--compact sq-btn is-primary"
                disabled={busy || short}
                onClick={() => advance(q, s)}
              >
                {s.type === 'deliver' ? tl(`Teslim et (${s.count}/${s.need})`, `Deliver (${s.count}/${s.need})`) : tl('Konuş', 'Talk')}
              </button>
            </div>
          </div>
        );
      })}
      {message ? <p className="sq-line">{message}</p> : null}
      {error ? <p className="sq-error" role="alert">{error}</p> : null}
    </div>
  );
};

export default StoryNpcTasks;
